import React, {
    CSSProperties,
    PropsWithChildren,
    ReactElement,
    useEffect,
    useRef,
    useState,
} from 'react'

import * as styles from './styles.scss'

interface CollapseProps {
    isOpened: boolean
}

function Collapse({
    children,
    isOpened,
}: PropsWithChildren<CollapseProps>): ReactElement {
    const content = useRef<HTMLDivElement>(null)
    const [height, setHeight] = useState<CSSProperties['height']>(
        isOpened ? 'auto' : 0
    )
    const [overflow, setOverflow] = useState(isOpened ? 'visible' : 'hidden')
    const [visibility, setVisibility] = useState<CSSProperties['visibility']>(
        isOpened ? 'visible' : 'hidden'
    )

    function onTransitionEnd(e: React.TransitionEvent<HTMLDivElement>): void {
        if (e.target === content.current && e.propertyName === 'height') {
            if (isOpened) {
                setHeight('auto')
                setOverflow('visible')
                setVisibility('visible')
            } else {
                setHeight(0)
                setOverflow('hidden')
                setVisibility('hidden')
            }
        }
    }

    useEffect(() => {
        if (isOpened) {
            setHeight(`${content.current?.scrollHeight ?? 0}px`)
            setOverflow('visible')
            setVisibility('visible')
        } else {
            setHeight(0)
            setOverflow('hidden')
        }
    }, [isOpened])

    return (
        <div
            ref={content}
            style={{ height, overflow, visibility }}
            className={styles['collapse-wrapper']}
            onTransitionEnd={onTransitionEnd}
        >
            {children}
        </div>
    )
}

export default Collapse
